<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Ship Last Position</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Ship Last Position</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <Dropdown @change="companyChanged" v-model="company" :options="companies" optionLabel="name" dataKey="value" placeholder="Company" :required="true" :filter="true" filterPlaceholder="Company" />
        <ion-item>
            <ion-label position="floating">Client <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="clientChanged" v-model="postData['client_id']">
                <ion-select-option v-for="(client,i) of clients" :key="i" :value="client.id">{{client.client_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['ship_id']">
                <ion-select-option v-for="(ship,i) of ships" :key="i" :value="ship.id">{{ship.ship_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-button expand="block" @click="search()" color="primary">Search</ion-button>
        <template v-if="positions.length > 0">
            <ion-text color="secondary">
            <h2>Last Update Time</h2>
            <p>{{lasttime}}</p>
        </ion-text>
        <ion-text color="secondary">
            <h2>Battery</h2>
            <p>{{battery}}</p>
        </ion-text>
        </template>
            <DataTable class="p-datatable-sm" :loading="loading" :value="positions" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                <template #loading>
                    Loading data, please wait...
                </template>
                <template #empty>
                    No records found
                </template>
                <Column field="serial" header="#"></Column>
                <Column field="date" header="Date"></Column>
                <Column field="position" header="Position"></Column>
                <Column field="speed" header="Speed"></Column>
                <Column field="heading" header="Heading"></Column>
                <Column field="battery" header="Battery"></Column>
                <Column field="charging" header="Charging Status"></Column>
                <Column field="satellite" header="No. of Satellite"></Column>
                <Column field="signal_strength_sim_1" header="Sim 1 Signal"></Column>
                <Column field="signal_strength_sim_2" header="Sim 2 Signal"></Column>
                <Column field="temperature" header="Temperature"></Column>
                <Column field="humidity" header="Humidity"></Column>
            </DataTable>
      </div>
    </ion-content>
  </ion-page>
</template>

<script >
import { IonButtons, IonText, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonLabel,IonSelect,IonSelectOption,alertController } from '@ionic/vue';
import Loading from '../Loading';
import Dropdown from './modules/Dropdown.vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
export default {
  name: 'Create Service Requisition',
  data(){
    return {
    lasttime:null,
    battery:null,
    companies:[],
    company:'',
    clients:[],
    ships:[],
    loading:false,
    positions:[],
    postData:{
        'company_id':null,
        'client_id':null,
        'ship_id':null,
    }
    }
  },
  created(){
    this.$http.get('getCompany',).then(response=>{
        const coms=[];
        for(const com of response.data){
            coms.push({
                name:com.company_name,
                value:com.id
            });
        }
        this.companies=coms;
    });
  },
  methods:{
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async search(){
        const requireds=[
            'company_id',
            'client_id',
            'ship_id',
        ];
        for(const required of requireds){
            if(this.postData[required]=='' || this.postData[required]==null){
                let name=required;
                name=name.replace('_id','');
                name=name.replace('_',' ');
                this.presentAlert(name);
                return;
            }
        }
        const data=this.postData;
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
        this.loading=true;
      this.$http.post('getShipLastPosition',data).then(response=>{
        if(response.status==200){
            this.loading=false;
            this.positions=[];
            let serial=1;
            this.battery=response.data.battery;
            this.lasttime=response.data.position;
            for(const pos of response.data.log){
                this.positions.push({
                    serial: serial++,
                    date:pos.device_time,
                    position:pos.lat+', '+pos.lng,
                    speed:pos.speed,
                    heading:pos.heading,
                    battery: pos.battery+'%',
                    charging: pos.charging_status,
                    humidity: pos.humidity,
                    satellite: pos.satellite,
                    'signal_strength_sim_1': pos.signal_strength_sim_1,
                    'signal_strength_sim_2': pos.signal_strength_sim_2,
                    temperature: pos.temperature
                });
            }

        }
      });      
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
    async companyChanged(){
        const loading = await Loading.presentLoading('Loading');
        this.postData['company_id']=this.company.value;
        this.postData['client_id']=null;
        this.$http.get('getClient',{params:{id:this.company.value}}).then(response=>{
            this.clients=response.data;
            loading.dismiss();
        });
    },
    async clientChanged(){
        this.postData['ship_id']=null;
        const loading = await Loading.presentLoading('Loading');
        this.$http.get('getShip',{params:{id:this.postData['client_id']}}).then(response=>{
            this.ships=response.data;
            loading.dismiss();
        });
    },
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    Dropdown,
    Column,
    DataTable,
    IonText
  }
  
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
</style>